// AdminLayout.jsx — shared sidebar shell for all admin sub-pages
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/* ── icons ── */
export const GridIcon    = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="1" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/><rect x="1" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/><rect x="9" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".5"/></svg>;
export const UsersIcon   = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M1 13c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.3"/><path d="M14 13c0-2-1.3-3.6-3-4.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
export const TruckIcon   = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="5" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/><path d="M11 7h2l2 3v2h-4V7z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><circle cx="4" cy="13" r="1.5" fill="currentColor"/><circle cx="12" cy="13" r="1.5" fill="currentColor"/></svg>;
export const TicketIcon  = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="4" width="14" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M5 8h6M5 5.5h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
export const ChartIcon   = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M1 12l4-4 3 2 4-5 3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
export const CogIcon     = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.2 3.2l1.4 1.4M11.4 11.4l1.4 1.4M3.2 12.8l1.4-1.4M11.4 4.6l1.4-1.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
export const LogoutIcon  = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3M10 11l3-3-3-3M13 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
export const BarsIcon    = () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 4h14M2 9h14M2 14h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
export const ArrowIcon   = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;

const NAV = [
  { to:"/admin",              icon:<GridIcon />,   label:"Dashboard"      },
  { to:"/admin/users",        icon:<UsersIcon />,  label:"Utilisateurs"   },
  { to:"/admin/transporters", icon:<TruckIcon />,  label:"Transporteurs"  },
  { to:"/admin/bookings",     icon:<TicketIcon />, label:"Réservations"   },
  { to:"/admin/revenue",      icon:<ChartIcon />,  label:"Revenus"        },
  { to:"/admin/settings",     icon:<CogIcon />,    label:"Paramètres"     },
];

const SidebarInner = ({ location, logout, close }) => (
  <div style={ls.inner}>
    <div style={ls.logoRow}>
      <Link to="/admin" style={ls.logo} onClick={close}>Trans<span style={{ color:"#4ade80" }}>Tigo</span></Link>
      <span style={ls.adminPill}>Admin</span>
    </div>
    <nav style={ls.nav}>
      {NAV.map(({ to, icon, label }) => {
        const active = location.pathname === to;
        return (
          <Link key={to} to={to} onClick={close} style={{ ...ls.navItem, ...(active ? ls.navActive : {}) }}>
            <span style={{ ...ls.navIcon, color: active ? "#4ade80" : "#8b8fa8" }}>{icon}</span>
            {label}
            {active && <div style={ls.bar} />}
          </Link>
        );
      })}
    </nav>
    <div style={ls.footer}>
      <button style={ls.logoutBtn} onClick={logout}>
        <LogoutIcon /> Déconnexion
      </button>
    </div>
  </div>
);

const AdminLayout = ({ children, title, subtitle }) => {
  const location     = useLocation();
  const { logout }   = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div style={ls.page}>
      <style>{layoutCSS}</style>

      

      {open && <div style={ls.overlay} onClick={() => setOpen(false)} />}

      {/* sidebar */}
      <div style={{ ...ls.sidebar, ...(open ? ls.sidebarOpen : {}) }} className="admin-sidebar">
        <SidebarInner location={location} logout={logout} close={() => setOpen(false)} />
      </div>

      {/* main */}
      <div style={ls.main}>
        {/* page header */}
        <div style={ls.pageHeader}>
          <div>
            <h1 style={ls.pageTitle}>{title}</h1>
            {subtitle && <p style={ls.pageSub}>{subtitle}</p>}
          </div>
          <Link to="/admin" style={ls.backBtn}>
            <ArrowIcon /> Retour
          </Link>
        </div>
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;

const ls = {
  page:       { display:"flex", background:"#0f1117", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif" },
  sidebar:    { width:220, background:"#16181f", borderRight:"0.5px solid #2a2d38", flexShrink:0, position:"sticky", top:0, height:"100vh" },
  sidebarOpen:{ position:"fixed", left:0, top:0, zIndex:200, height:"100%" },
  inner:      { display:"flex", flexDirection:"column", height:"100%", padding:"0 0 24px" },
  logoRow:    { display:"flex", alignItems:"center", gap:8, padding:"22px 20px 18px", borderBottom:"0.5px solid #2a2d38" },
  logo:       { fontSize:18, fontWeight:700, color:"#e8e9ed", letterSpacing:-0.5, textDecoration:"none" },
  adminPill:  { fontSize:9, fontWeight:700, background:"rgba(74,222,128,0.15)", color:"#4ade80", padding:"2px 7px", borderRadius:20, textTransform:"uppercase", letterSpacing:0.8 },
  nav:        { display:"flex", flexDirection:"column", gap:2, padding:"12px 0", flex:1 },
  navItem:    { display:"flex", alignItems:"center", gap:10, padding:"9px 16px", fontSize:13, color:"#8b8fa8", textDecoration:"none", position:"relative", transition:"all 0.12s" },
  navActive:  { color:"#e8e9ed", background:"rgba(255,255,255,0.04)" },
  navIcon:    { width:16, height:16, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 },
  bar:        { position:"absolute", left:0, top:0, bottom:0, width:2, background:"#4ade80", borderRadius:"0 2px 2px 0" },
  footer:     { padding:"0 12px", marginTop:"auto" },
  logoutBtn:  { display:"flex", alignItems:"center", gap:8, padding:"10px 16px", fontSize:13, color:"#8b8fa8", background:"none", border:"none", cursor:"pointer", fontFamily:"inherit", width:"100%", borderRadius:8 },
  topbar:     { display:"none", alignItems:"center", justifyContent:"space-between", padding:"0 20px", height:56, background:"#16181f", borderBottom:"0.5px solid #2a2d38", position:"sticky", top:0, zIndex:100 },
  overlay:    { position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:199 },
  iconBtn:    { background:"none", border:"0.5px solid #2a2d38", borderRadius:8, color:"#8b8fa8", cursor:"pointer", padding:"7px 8px", display:"flex" },
  main:       { flex:1, padding:28, overflowX:"hidden" },
  pageHeader: { display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:24 },
  pageTitle:  { fontSize:20, fontWeight:700, color:"#e8e9ed", letterSpacing:-0.4, margin:0 },
  pageSub:    { fontSize:13, color:"#8b8fa8", marginTop:4 },
  backBtn:    { display:"flex", alignItems:"center", gap:6, fontSize:13, color:"#8b8fa8", textDecoration:"none", padding:"8px 14px", border:"0.5px solid #2a2d38", borderRadius:9, background:"#16181f", flexShrink:0 },
};

const layoutCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
  .admin-sidebar a:hover { color: #e8e9ed !important; background: rgba(255,255,255,0.03) !important; }
  .admin-sidebar button:hover { color: #f87171 !important; }
  @media(max-width:992px){
    .admin-topbar { display:flex !important; }
    .admin-sidebar { display:none !important; }
  }
`;